import '../CssStykes/Profile.css'
export default function Projects() {
    return (

        <>
        <div className='project-body'>
            <div className="projects">
                <h2 className="projects-head"><strong>My Projects</strong></h2>
                <div className="projects-images">
                    <div className="project-names"><div class="section project">
                        <h3>Bus Trading System</h3>
                        <p>Description: it is Bus Rental website where customers can order the vehicle from our website and you can return  back to us by paying as per usage</p>
                        <p>Technologies Used: <br/>Fronte End:HTML, CSS, React Js<br/>Backend:SpringBoot,java<br/>DataBase:MySQL</p>
                        
                    </div></div>
                    <div className="project-names"> <div class="section project">
                        <h3>Digital Library </h3>
                        <p>Description:A digital library website is an online platform designed to provide users with access to a vast collection of digital resources, including books, articles, multimedia content, and more.</p>
                        <p>Technologies Used:<br/> Backend:Java,SpringBoot<br/>Frontend:Reactjs,Html,CSS<br/>DataBase:SQL</p>
                        
                    </div></div>
                    <div className="project-names"> <div class="section project">
                        <h3>QUIZ APPLICATION</h3>
                        <p>Description: A quiz application is a software platform designed to create, deliver, and manage quizzes, assessments, and tests. It's a versatile tool used in education, training, and entertainment. </p>
                        <p>Technologies Used:<br/> Backend:Java,SpringBoot<br/>Frontend:Reactjs,Html,CSS<br/>DataBase:SQL</p>
                        
                    </div></div>
                    <div className="project-names"> <div class="section project">
                        <h3>AUDIO TO SIGN LANGUAGE CONVERTER</h3>
                        <p>Description: it converts audio to sign language which makes the bridge between Deaf and Dumb people to Normal people </p>
                        <p>Technologies Used:<br/>Speech Recognition:Google Cloud Speech-to-Text<br/>User Interface (UI) Development:HTML, CSS, JavaScrip<br/>Backend Server and Deployment:Django<br/>Natural Language Processing(NLP),python</p>
                        
                    </div></div>

                </div>
            </div>
            </div>
        </>
    )
}